export const USER_RESET = "USER_RESET";
export const USER_SET_ERROR = "USER_SET_ERROR";
export const USER_SET_ITEMS = "USER_SET_ITEMS";
export const USER_TOGGLE_LOADING = "USER_TOGGLE_LOADING";
